<template>
    <div class="content-wrap content-wrap--full" :class="{ 'no-scroll' : ! listScrollable }">
        <header>
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 30px;" class="">
                <router-link class="footer-link footer-link--emergency" :to="{ name : 'Notfall'}"><img src="@/assets/images/icons/ic_notfall_bw.svg" alt="" width="30"></router-link>
                <span><img src="@/assets/images/icons/ic_kassecker.svg" alt="" width="30"></span>
                <router-link :to="{name: 'Profile'}"><img src="@/assets/images/icons/ic_profil_small.svg" alt="" width="30"></router-link>
            </div>
        </header>
        <kapp-nav :status="navStatus" type="shelf" />

        <div class="content-block" v-if="this.barometerActive">

            <router-link :to="{name: 'Barometer'}" class="block block--info">
                <img src="@/assets/images/icons/ic_barometer.svg" alt="" width="40">
                <h3>Quartalsbarometer</h3>
                <p>Stimme jetzt wieder im Quartalsbarometer ab und sage uns, was dir gefällt und was wir verbessern können.</p>
            </router-link>
        </div>

        <div class="content-block">
            <div class="content-header">
                <h2>News &amp; Aktuelles</h2>
            </div>
            <div style="margin-bottom: 16px;">
                <kapp-news v-for="(article,idx) in newsList" :article="article" :uid="article.uid" :available_categories="$store.getters.newsCategories" :key="'news-' + idx" />
            </div>
            <router-link :to="{path: '/neuigkeiten'}" class="button button--primary">alle News ansehen</router-link>
        </div>

        <!-- <div class="content-block">
            <div class="content-header">
                <h2>Eure Beitr&auml;ge</h2>
                <router-link :to="{name: 'ImpressionsNew'}" class="content-link"><i class="icon-plus_x"></i> NEUER&nbsp;BEITRAG</router-link>
            </div>

            <div style="margin-bottom: 16px;">
                <kapp-news v-for="(article,idx) in impressionsList" :article="article" :uid="article.uid" :key="'impression-' + idx" layout="impression" :like_settings="{pid: 17, target: 'impression'}" />
            </div>
            <router-link :to="{name: 'ImpressionsList'}" class="button button--primary">ALLE BEITR&Auml;GE ANSEHEN</router-link>
            <router-link :to="{name: 'ImpressionsNew'}" class="button">NEUEN BEITRAG ERSTELLEN</router-link>
        </div> -->
    </div>
</template>

<script>

    import KappMainNav from "../components/KappMainNav";
    import debounce from 'lodash.debounce';
    import api, { ApiDefaults } from '../utils/api_call';
    import { STORE_EVENTS, STORE_NEWS, STORE_NEWS_CATEGORIES, STORE_IMPRESSIONS } from '../utils/store/actions/general';
    import KappNews from './blocks/KappNews';
    // import * as Push from '@/utils/firebase';

    export default {
        name: "KappMain",
        components: {
            'kapp-nav': KappMainNav,
            'kapp-news': KappNews
        },
        data() {
            return {
                navStatus: 'is-opening',
                listScrollable: true,
                // categoriesVisible: true
            };
        },
        computed: {
            barometerActive() {
                return this.$store.getters.navigationHasItem('Barometer');
            },
            newsList() {
                let list = [].concat(this.$store.getters.newsItems);
                list = list.splice(0, 3);
                return list;
            },
            impressionsList() {
                let list = [].concat(this.$store.getters.impressionItems);
                list = list.splice(0, 3);
                return list;
            }
        },
        methods: {
            fetchNews: debounce(function () {
                let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 2}});
                api(apiParams)
                    .then(( response ) => {
                        if ( response.status === 200 ) {

                            let newsArticles = response.data.news.content.map(( item ) => {

                                                           item.categories = [ parseInt(item.categories) ];
                                                           item.visible = true;

                                                           return item;
                                                       })
                                                       .sort(( a, b ) => {
                                                           return b.datetime - a.datetime;
                                                       });
                            this.$store.commit(STORE_NEWS, newsArticles);
                            this.$store.commit(STORE_NEWS_CATEGORIES, Object.values(response.data.news.categories));
                        }
                    })
                    .catch(( err ) => {
                        console.warn(err.message);
                    })
                    .finally(() => this.hideArticleEffect = 'hideArticles');


            }, 125),
            fetchImpressions: debounce(function () {
                let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 35}});
                api(apiParams)
                    .then(( response ) => {
                        if ( response.status === 200 ) {

                            let newsArticles = response.data.news.content.map(( item ) => {

                                                           item.categories = [ parseInt(item.categories) ];
                                                           item.visible = true;

                                                           return item;
                                                       })
                                                       .sort(( a, b ) => {
                                                           return b.datetime - a.datetime;
                                                       });

                            this.$store.commit(STORE_IMPRESSIONS, newsArticles);
                            // let categories = Object.values( response.data.news.categories );
                            // console.log( categories );
                            // this.$store.commit( STORE_NEWS_CATEGORIES, categories );
                        }
                    })
                    .catch(( err ) => {
                        console.warn(err.message);
                    })
                    .finally(() => this.hideArticleEffect = 'hideArticles');


            }, 125),
            fetchEvents: debounce(function () {

                let apiParams = Object.assign({}, ApiDefaults, {method: 'get', params: {id: 13}});
                api(apiParams)
                    .then(( response ) => {
                        if ( response.status === 200 ) {
                            if ( response.status === 200 ) {
                                if ( response.data.hasOwnProperty('news') ) {
                                    let events = response.data.news.content;

                                    events.map(function ( evt ) {
                                        let usedCategory = this[ evt.categories ];

                                        evt.color = false; // set Default value
                                        if ( usedCategory.hasOwnProperty('color') ) {
                                            evt.color = usedCategory.color;
                                        }

                                        return evt;
                                    }, response.data.news.categories);

                                    this.$store.commit(STORE_EVENTS, events);
                                }
                            }
                        }
                    })
                    .catch(( err ) => {
                        console.warn(err.message);
                    })
                    .finally(() => this.hideArticleEffect = 'hideArticles');


            }, 125),
            lightbox: function ( evt ) {
                this.listScrollable = !evt.state;
                // this.categoriesVisible = !evt.state;
            },
        },
        created() {
            this.fetchNews();
            this.fetchEvents();
            this.fetchImpressions();
            Events.$emit('showCategories', []);
            Events.$on('lightbox', this.lightbox );
        },
        mounted (){
            // this.$nextTick(function () {
            //     // console.log('push Register' );
            // // window.addEventListener('load', async () => {
            // //     Push.firebaseMessage();
            // // });
            // });
        },
        watch: {
            '$route'( to, from ) {
                if ( from.name !== 'KappLogin' ) {
                    this.navStatus = 'is-open';
                }
                else {
                    this.navStatus = 'is-opening';
                }
            }
        }
    };
</script>

<style scoped>

    .content-block + .content-block {
        margin-top: 60px;
        padding-top: 60px;
        border-top: 2px solid #1A2026;
    }

    .block.block--info {
        padding-left: 40px;
        position: relative;
        font-size: 12px;
        line-height: calc(16 / 12);
    }

    .block.block--info h3 {
        font-size: 14px;
        margin: 0;

    }

    .block.block--info.block.block--info p {
        margin-top: 8px;
    }

    .block.block--info img {
        position: absolute;
        top: 50%;
        left: -15px;
        transform: translate(-0, -50%);
    }
</style>



// WEBPACK FOOTER //
// src/components/KappMain.vue